import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import Model3D from '@/components/Model3D';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/i18n';

interface ItemProps {
    tab: string;
    glb: string;
    pc?: string;
    glb2?: string;
}

export default function Comp() {
    const { t } = useLang('theProduct');
    const [activeTab, setActiveTab] = useState(0);
    const [activeIcon, setActiveIcon] = useState('1');
    const { locale = 'us' } = getLocal();
    const IS_JP_SITE = ['jp'].includes(locale);
    const IS_EU_SITE = ['eu', 'uk', 'fr', 'de', 'it', 'es'].includes(locale);

    const handleGtm = (idx: number) => {
        let button_name = 'Rotate Product Icon';
        if (activeTab === 0) {
            button_name = idx === 0 ? 'Rotate Product Icon' : 'Product Size Icon';
        } else if (activeTab === 1) {
            button_name = idx === 0 ? 'Rotate Product Icon' : IS_JP_SITE || IS_EU_SITE ? 'Install Icon' : 'Product Install Icon';
        }

        gtm.push({
            event: 'uaEvent',
            event_name: 'product_detail_page',
            list_name: t('M_title'),
            button_name,
        });
    };
    const items: ItemProps[] = [
        {
            tab: t('M_tab1'),
            glb: 'https://websiteoss.ecoflow.com/upload/image/1744339047079/Wave3.glb',
            // glb: 'https://websiteoss.ecoflow.com/upload//1764655891016/robot.usdz',
            pc:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1744773550952/US.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744351910964/3d-img.png',
            glb2: 'https://websiteoss.ecoflow.com/upload/image/1744339047571/Wave3%2B%E7%AE%A1%E9%81%93%2BEB.glb',
        },
        {
            tab: t('M_tab2'),
            glb: 'https://websiteoss.ecoflow.com/upload/image/1744339047348/Wave3%2BEB.glb',
            // glb: 'https://websiteoss.ecoflow.com/upload//1764655902626/imac-4port-magic-keyboard-tid-magic-mouse-pink-ios18-6B70C197294031F2.usdz',
            pc:
                locale === 'us'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1744773550952/US.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1744351910964/3d-img.png',
            glb2: 'https://websiteoss.ecoflow.com/upload/image/1744339047571/Wave3%2B%E7%AE%A1%E9%81%93%2BEB.glb',
        },
    ];

    const icons: { key: string; icon: JSX.Element }[] = [
        {
            key: '1',
            icon: (
                <svg width="1em" height="1em" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2624_12466)">
                        <path
                            d="M67.126 16.1748L71.126 25.0748L72.976 27.5998L70.726 57.7248L68.326 61.3248L46.376 64.3748H39.201L7.40098 60.1998L7.00098 56.1498L7.85098 30.1248L9.52598 24.4498L45.026 15.6748L67.101 16.1998"
                            stroke="currentColor"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M33.7764 18.7471L46.3264 30.2471L45.3514 58.7971L39.2014 64.3721"
                            stroke="currentColor"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M44.9275 15.623L44.3525 21.573L47.8275 24.648L70.8275 24.423L67.1025 16.148L44.9275 15.623Z"
                            stroke="currentColor"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M72.4244 35.0734L68.7994 30.2734L52.9744 30.5484L46.1494 35.0984"
                            stroke="currentColor"
                            stroke-width="4"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path d="M56.1502 30.4717L54.8252 63.1967" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M64.1732 30.3486L62.6982 62.0986" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_2624_12466">
                            <rect width="80" height="80" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            key: '2',
            icon: (
                <svg width="1em" height="1em" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.2306 20.042V36.1928" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    <path
                        d="M5.55225 12.8066L19.5736 19.9084C19.9473 20.0977 20.3883 20.0996 20.7636 19.9138L35.1145 12.8066"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.8304 4.87778C20.4468 4.68067 19.9914 4.68202 19.6089 4.88142L5.33352 12.3245C4.89447 12.5534 4.61914 13.0075 4.61914 13.5026L4.61914 27.9259C4.61914 28.4211 4.89447 28.8751 5.33352 29.104L19.6089 36.5471C19.9914 36.7465 20.4468 36.7479 20.8304 36.5508L35.3263 29.1023C35.7692 28.8747 36.0477 28.4185 36.0477 27.9205V13.508C36.0477 13.0101 35.7692 12.5539 35.3263 12.3263L20.8304 4.87778Z"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                    />
                </svg>
            ),
        },
        {
            key: '3',
            icon: (
                <svg width="1em" height="1em" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.0684 7.69944C7.75573 10.0122 7.75572 13.7618 10.0684 16.0746C10.7767 16.7828 11.6177 17.273 12.5105 17.5474C12.8603 17.6549 13.099 17.978 13.099 18.344V34.6884H15.413L15.413 26.0995L15.413 18.344C15.413 17.978 15.6517 17.6549 16.0015 17.5474C16.8943 17.273 17.7353 16.7828 18.4436 16.0746C20.7563 13.7618 20.7563 10.0122 18.4436 7.69944C18.029 7.28488 17.5689 6.94502 17.0797 6.67942L17.0797 11.4889C17.0797 11.7099 16.9919 11.9219 16.8356 12.0782C16.6793 12.2345 16.4673 12.3223 16.2463 12.3223L12.2657 12.3223C11.8054 12.3223 11.4323 11.9492 11.4323 11.4889L11.4323 6.67941C10.943 6.945 10.483 7.28487 10.0684 7.69944ZM8.88993 17.2531C5.92633 14.2895 5.92634 9.48452 8.88993 6.52093C9.79518 5.61568 10.8744 4.98578 12.0209 4.63345C12.2736 4.55578 12.5482 4.60266 12.7609 4.75978C12.9735 4.9169 13.099 5.16562 13.099 5.43002L13.099 10.6556L15.413 10.6556L15.413 5.43002C15.413 5.16562 15.5385 4.9169 15.7511 4.75978C15.9638 4.60266 16.2384 4.55579 16.4911 4.63346C17.6376 4.9858 18.7168 5.61567 19.6221 6.52093C22.5857 9.48452 22.5857 14.2895 19.6221 17.2531C18.8734 18.0017 18.0059 18.562 17.0797 18.9327V26.0995L17.0797 35.5218C17.0797 35.982 16.7066 36.3551 16.2463 36.3551L12.2657 36.3551C12.0446 36.3551 11.8327 36.2673 11.6764 36.111C11.5201 35.9548 11.4323 35.7428 11.4323 35.5218L11.4323 18.9327C10.5061 18.562 9.63855 18.0017 8.88993 17.2531ZM27.1666 19.8332H29.5V11.6666C29.5 11.502 29.5487 11.3412 29.6399 11.2043L30.7472 9.54343L29.7327 6.49989H26.9339L25.9194 9.54343L27.0267 11.2043C27.1179 11.3412 27.1666 11.502 27.1666 11.6666V19.8332ZM31.1666 19.8666V11.9189L32.36 10.1288C32.5027 9.91484 32.5385 9.647 32.4572 9.40304L31.1239 5.40304C31.0104 5.06275 30.692 4.83322 30.3333 4.83322H26.3333C25.9746 4.83322 25.6562 5.06275 25.5427 5.40304L24.2094 9.40304C24.1281 9.647 24.1639 9.91484 24.3066 10.1288L25.5 11.9189V19.8666C24.7392 20.021 24.1666 20.6936 24.1666 21.4999V34.8332C24.1666 35.7537 24.9128 36.4999 25.8333 36.4999H30.8333C31.7538 36.4999 32.5 35.7537 32.5 34.8332V21.4999C32.5 20.6936 31.9274 20.021 31.1666 19.8666ZM30.3339 21.4999C30.3337 21.4999 30.3335 21.4999 30.3333 21.4999H26.3333C26.3327 21.4999 26.3322 21.4999 26.3316 21.4999H25.8333V34.8332L30.8333 34.8332V21.4999H30.3339Z"
                        fill="currentColor"
                    />
                </svg>
            ),
        },
    ];

    const handleChangeTab = (k: number) => {
        setActiveTab(k);
        setActiveIcon('1');
    };

    return (
        <div className={styles.comp} id="Animation3d">
            <div className="content">
                <div className="side">
                    <h2 className="title">{t('M_title')}</h2>
                    <ul className="tabs">
                        {items?.map((item: ItemProps, k: number) => (
                            <li className={`tab ${k === activeTab ? ' active' : ''}`} key={k} onClick={() => handleChangeTab(k)}>
                                {item.tab}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="box">
                    {['1', '3'].includes(activeIcon) && (
                        <div className="inner" id="three-container">
                            <Model3D
                                props={{
                                    style: { width: '100%', height: '100%' },
                                    loading: 'lazy',
                                    src: activeIcon === '3' && items[activeTab]?.glb2 ? items[activeTab].glb2 : items[activeTab].glb,
                                }}
                            />
                        </div>
                    )}
                    {activeIcon === '2' && (
                        <div className="inner">
                            <EcoImg pc={items[activeTab]?.pc} />
                        </div>
                    )}
                    <ul className="icons">
                        {icons
                            .filter((i) => (activeTab === 0 ? ['1', '2'].includes(i.key) : ['1', '3'].includes(i.key)))
                            .map((i: any, k: number) => (
                                <li
                                    className={`icon${i.key === activeIcon ? ' active' : ''}`}
                                    key={k}
                                    onClick={() => {
                                        handleGtm(k);
                                        setActiveIcon(i.key);
                                    }}
                                >
                                    {i.icon}
                                </li>
                            ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
